import applyIsoDuration from '@bridebook/toolbox/src/applyIsoDuration';
import { format } from 'date-fns';

// Near-term checklist periods show as relative text ("3 months to go"), as in the app's
// checklist. All other periods resolve to a calendar month.
const RELATIVE_PERIOD_LABELS: Record<string, string> = {
  '-P3M': '3 months to go',
  '-P1M': '1 month to go',
  '-P1W': '1 week to go',
  P: 'Wedding day',
  '+P': 'After the wedding',
};

const UNIT_LABELS: Record<string, string> = {
  Y: 'year',
  M: 'month',
  W: 'week',
  D: 'day',
};

// Without a wedding date there is no calendar month, so build a relative phrase from the
// ISO duration (e.g. "-P12M" → "12 months before").
const relativeFromIsoDuration = (period: string): string => {
  const match = period.match(/^-P(\d+)([YMWD])$/);
  if (!match) {
    return period;
  }
  const amount = Number.parseInt(match[1], 10);
  const unit = UNIT_LABELS[match[2]] ?? match[2];
  return `${amount} ${unit}${amount === 1 ? '' : 's'} before`;
};

/**
 * Human-readable label for a checklist task period — an ISO 8601 duration
 * relative to the wedding date (e.g. "-P12M", "-P1W", "P", "+P").
 */
export const getPeriodName = (weddingDate: Date | null, period: string): string => {
  if (!period) {
    return '';
  }
  const relative = RELATIVE_PERIOD_LABELS[period];
  if (relative) {
    return relative;
  }
  if (weddingDate && !Number.isNaN(weddingDate.getTime())) {
    return format(applyIsoDuration(weddingDate, period), 'MMM yyyy');
  }
  return relativeFromIsoDuration(period);
};
